import { Engine1Proxy, RestApiProxy } from 'com-gyf-webcore-servicehub';

let BajaCuentaTarjetaManager = function () {

    const isQuery = false;
    const deleteInstance = false;

    /**
     * 
     * @param {any} cuentaTarjeta
     * @param {any} viewCallback
     */
    function _bajaCuentaTarjeta(cuentaTarjeta, viewCallback) {
        let localValues = mapearBajaCuentaTarjeta(cuentaTarjeta);
        localValues.SolicitaCaidaCuota = cuentaTarjeta.SolicitaCaidaCuota;
        Engine1Proxy.AddEventSourcingDataRequest(localValues.bajaCuenta, 'EVENTSOURCING_BAJA_CUENTA', 'Tarjetas', 'ADMINEMPCUETAR', null, true, null, deleteInstance);
        Engine1Proxy.AddEventSourcingDataRequest(localValues.cuentaTarjetaEstado, 'EVENTSOURCING_TRANSACTION_CUENTA_TARJETA', 'Tarjetas', 'SOLICITUD', null, isQuery, null, deleteInstance, cuentaTarjeta.Id);

        if (cuentaTarjeta.SaldoALaBaja > 0) {
            Engine1Proxy.AddEventSourcingDataRequest({ "CODIGO": 'E' }, 'GET_ATLAS_MOTIVO_INHABILITADO_CODIGO', 'Tarjetas', 'PARAMETRIA', null, true, null, deleteInstance);
            Engine1Proxy.Execute((data) => callbackSave(data, localValues, viewCallback), null, null, "ADMINEMPCUETAR");
        }
        else {
            Engine1Proxy.Execute((data) => callbackSaveBaja(data, localValues, viewCallback), null, null, "ADMINEMPCUETAR");
        }
    }

    /**
     * 
     * @param {any} cuentaTarjeta
     */
    function mapearBajaCuentaTarjeta(cuentaTarjeta) {
        let now = new Date();
        let values = {
            bajaCuenta: {
                "SUCURSAL_PEDIDO_ID": cuentaTarjeta.SucursalPedidoId,
                "CUENTA_TARJETA_ID": cuentaTarjeta.Id,
                "TIPO_BAJA": cuentaTarjeta.TipoBaja,
                "MOTIVO_BAJA_ID": cuentaTarjeta.MotivoBajaId,
                "SOLICITA_CAIDA_CUOTA": cuentaTarjeta.SolicitaCaidaCuota,
                "COMENTARIOS": cuentaTarjeta.Comentarios,
                "FECHA_SOLICITUD": now,
                "FECHA_BAJA": null,
                "USUARIO_LOGIN": cuentaTarjeta.UsuarioLogin,
                "ORIGEN": 0,
                "SALDO_A_LA_BAJA": cuentaTarjeta.SaldoALaBaja
            }
        };

        values.cuentaTarjetaEstado = {
            "CUENTA_TARJETA_ESTADO_ID": 7
        }

        if (cuentaTarjeta.SaldoALaBaja == 0) {
            values.novedadBajaCuenta = {
                "BAJA_CUENTA_TARJETA_ID": null,
                "FECHA_CREACION": now,
                "FECHA_BAJA": now,
                "USUARIO_ALTA": cuentaTarjeta.UsuarioLogin,
                "USUARIO_MODIFICACION": cuentaTarjeta.UsuarioLogin,
                "NOVEDAD_ESTADO_ID": 2
            }
        } else {
            values.boletinamiento = {
                "CUENTA_TARJETA_ID": cuentaTarjeta.Id,
                "BAJA_CUENTA_TARJETA_ID": null,
                "EMPRESA_ID": null,
                "TIPO_BOLETINAMIENTO": 'A',
                "MARCA_ORIGEN": null,
                "FECHA_CREACION": now,
                "FECHA_BOLETINAMIENTO": null,
                "USUARIO_ALTA": cuentaTarjeta.UsuarioLogin,
                "ORIGEN": 2
            }
            values.novedadBoletinamiento = {
                "BOLETINAMIENTO_ID": null,
                "CUENTA_TARJETA_ID": cuentaTarjeta.Id,
                "TARJETA_CREDITO_ID": null,
                "CODIGO_PROBLEMA": 'NC',
                "EMISION": 0,
                "RESCATE": 0,
                "MOTIVO_INHABILITADO_ID": null,
                "NIVEL_BOLETINAMIENTO_CUENTA": 2,
                "OBSERVACION": null,
                "FECHA_CREACION": now,
                "FECHA_MODIFICACION": now,
                "FECHA_BOLETINAMIENTO": null,
                "USUARIO_ALTA": cuentaTarjeta.UsuarioLogin,
                "USUARIO_MODIFICACION": cuentaTarjeta.UsuarioLogin,
                "NOVEDAD_ESTADO_ID": 2,
                "ORIGEN": 2,
                "TIPO_NOVEDAD": 'BLC'
            }

            if (cuentaTarjeta.SolicitaCaidaCuota) {
                values.caidaCuotas = {
                    "CUENTA_TARJETA_ID": cuentaTarjeta.Id,
                    "BAJA_CUENTA_TARJETA_ID": null,
                    "FECHA_CREACION": now,
                    "FECHA_CAIDA_CUOTAS": null,
                    "USUARIO_ALTA": cuentaTarjeta.UsuarioLogin,
                    "ORIGEN": 2 //(0-"AdintaR Directo" / 1-"Visa On-Line" / 2-"AdintaR Baja de Cuenta")
                }

                values.novedadCaidaCuotas = {
                    "CAIDA_CUOTA_ID": null,
                    "CUENTA_TARJETA_ID": cuentaTarjeta.Id,
                    "TARJETA_CREDITO_ID": null,
                    "NUMERO_LOTE": null,
                    "NUMERO_COMPROBANTE": null,
                    "FECHA_PRESENTACION_HASTA": now,
                    "MARCA_ORIGEN_FUNCIONARIO": "B", //Banco
                    "MARCA_ORIGEN": null,
                    "CODIGO_REGISTRO": null,
                    "ERROR_CAIDA_CUOTA_ID": null,
                    "FECHA_CREACION": now,
                    "FECHA_MODIFICACION": now,
                    "FECHA_CAIDA_CUOTA": null,
                    "USUARIO_ALTA": cuentaTarjeta.UsuarioLogin,
                    "USUARIO_MODIFICACION": cuentaTarjeta.UsuarioLogin,
                    "NOVEDAD_ESTADO_ID": 2, //("Confirmado")
                    "TIPO_NOVEDAD": 1, //("Solicitud de caída de cuotas a nivel Cuenta")
                    "ORIGEN": 0 //(0-"AdintaR")
                }
            }
        }
        return values;
    }

    /**
     * 
     * @param {any} data
     * @param {any} localValues
     * @param {any} viewCallback
     */
    function callbackSaveBaja(data, localValues, viewCallback) {
        const bajaId = data.EVENTSOURCING_BAJA_CUENTA;
        localValues.novedadBajaCuenta.BAJA_CUENTA_TARJETA_ID = bajaId;
        Engine1Proxy.AddEventSourcingDataRequest(localValues.novedadBajaCuenta, 'EVENTSOURCING_NOVEDAD_BAJA_CUENTA', 'Tarjetas', 'ADMINEMPCUETAR', null, isQuery, null, deleteInstance);
        Engine1Proxy.Execute((data) => callbackSaveBajaSaldos(data, bajaId, viewCallback), null, null, "ADMINEMPCUETAR");
    }

    /**
     * 
     * @param {any} data
     * @param {any} localValues
     * @param {any} viewCallback
     */
    function callbackSave(data, localValues, viewCallback) {
        let GET_ATLAS_MOTIVO_INHABILITADO_CODIGO = JSON.parse(data.GET_ATLAS_MOTIVO_INHABILITADO_CODIGO).Recordset0.Rows[0];
        localValues.bajaId = data.EVENTSOURCING_BAJA_CUENTA;

        localValues.novedadBoletinamiento.MOTIVO_INHABILITADO_ID = GET_ATLAS_MOTIVO_INHABILITADO_CODIGO.ID;
        
        if (localValues.SolicitaCaidaCuota == 1) {
            localValues.caidaCuotas.BAJA_CUENTA_TARJETA_ID = localValues.bajaId;
            Engine1Proxy.AddEventSourcingDataRequest(localValues.caidaCuotas, 'EVENTSOURCING_CAIDA_CUOTAS', 'Tarjetas', 'ADMINEMPCUETAR', null, true, null, deleteInstance);
        }

        localValues.boletinamiento.BAJA_CUENTA_TARJETA_ID = localValues.bajaId;

        Engine1Proxy.AddEventSourcingDataRequest(localValues.boletinamiento, 'EVENTSOURCING_BOLETINAMIENTO', 'Tarjetas', 'ADMINEMPCUETAR', null, true, null, deleteInstance);
        Engine1Proxy.Execute((data) => setFksSave(data, localValues, viewCallback), null, null, "ADMINEMPCUETAR");
    }

    /**
     * 
     * @param {any} data
     * @param {any} localValues
     * @param {any} viewCallback
     */
    function setFksSave(data, localValues, viewCallback) {
        if (localValues.SolicitaCaidaCuota == 1) {
            localValues.novedadCaidaCuotas.CAIDA_CUOTA_ID = data.EVENTSOURCING_CAIDA_CUOTAS;
            Engine1Proxy.AddEventSourcingDataRequest(localValues.novedadCaidaCuotas, 'EVENTSOURCING_NOVEDAD_CAIDA_CUOTAS', 'Tarjetas', 'ADMINEMPCUETAR', null, isQuery, null, deleteInstance);
        }

        localValues.novedadBoletinamiento.BOLETINAMIENTO_ID = data.EVENTSOURCING_BOLETINAMIENTO;
        Engine1Proxy.AddEventSourcingDataRequest(localValues.novedadBoletinamiento, 'EVENTSOURCING_NOVEDAD_BOLETINAMIENTO', 'Tarjetas', 'ADMINEMPCUETAR', null, isQuery, null, deleteInstance);
        Engine1Proxy.Execute((data) => callbackSaveBajaSaldos(data, localValues.bajaId, viewCallback), null, null, "ADMINEMPCUETAR");
    }

    /**
     * 
     * @param {any} data
     * @param {any} bajaId
     * @param {any} viewCallback
     */
    function callbackSaveBajaSaldos(data, bajaId, viewCallback) {
        viewCallback(bajaId);
    }

    return {
        BajaCuentaTarjeta: function (cuentaTarjeta, viewCallback) {
            return _bajaCuentaTarjeta(cuentaTarjeta, viewCallback);
        }
    }
};

let bajaCuentaTarjetaManager = new BajaCuentaTarjetaManager();

module.exports = bajaCuentaTarjetaManager;


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Common/Managers/BajaCuentaTarjetaManager.js